import { getVideoDuration } from '../videoUploadUtils';

const useUploadHandlers = (
  formState,
  uiState,
  setError,
  setFileDuration,
  setGoalAssociatedWithBehavior,
  setSelectCategory,
  setSelectedBehaviorIds,
  setSelectedSkillIds,
  setSelectedGoalIds,
  setOtherInputValue,
  setNewStudent,
  setNewPatient,
  setShowDialog,
  setSelectedStudent,
  setSelectedPatient,
  setIsResetConfirmed,
  setTherapyType,
  setInterventions,
  setAntecedent,
  setConsequence,
  setEditAndViewIds,
  setViewOnlyIds,
  setVideoFeedBackNotesPrivate,
  setInformation,
  setOpenVideoUpload,
  typeOfUser
) => {
  const {
    setUploadedFile,
    setCustomFileName,
    setDate,
    newStudent,
    newPatient,
  } = formState;

  // eslint-disable-next-line no-unused-vars
  const { setShowDialog: setShowDialogState } = uiState;

  // Event handlers
  const handleGoalAssociatedWithBehavior = (event) => {
    setGoalAssociatedWithBehavior(event.target.value === 'true');
    setSelectCategory('');
    setSelectedGoalIds([]);
    setSelectedBehaviorIds([]);
    setSelectedSkillIds([]);
    setOtherInputValue('');
  };

  const handleSelectCategory = (event) => {
    setSelectCategory(event.target.value);
    setSelectedBehaviorIds([]);
    setSelectedSkillIds([]);
    setOtherInputValue('');
  };

  const handleGoalIdChange = (event) => {
    setSelectedGoalIds(event.target.value);
  };

  const handleBehaviorIdChange = (event) => {
    setSelectedBehaviorIds(event.target.value);
  };

  const handleSkillIdChange = (event) => {
    setSelectedSkillIds(event.target.value);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFile(file);
      getVideoDuration(file, setFileDuration);
    }
  };

  const handleCustomFileNameChange = (e) => {
    setCustomFileName(e.target.value);
  };

  const dateChangeHandler = (newValue) => {
    if (newValue && newValue._d <= new Date()) {
      setDate(newValue._d);
      setError({ show: false, message: '' });
    } else {
      setDate(null);
      setError({
        show: true,
        message:
          'Select Valid Date, Video taken time cannot be greater than current time.',
      });
    }
  };

  const handleStudentSelection = (e) => {
    const selectedValue = e.target.value;
    setSelectedStudent(selectedValue);
    setNewStudent(selectedValue);
    setShowDialog(true);
  };

  const handlePatientSelection = (e) => {
    const selectedValue = e.target.value;
    setSelectedPatient(selectedValue);
    setNewPatient(selectedValue);
    setShowDialog(true);
  };

  const handleDialog = () => setShowDialog(false);

  const handleClose = () => {
    setOpenVideoUpload(false);
    setCustomFileName('');
    setSelectedStudent('');
    setSelectedPatient('');
  };

  const handleConfirmChange = () => {
    if (typeOfUser === 'Teacher') {
      setSelectedStudent(newStudent);
    } else {
      setSelectedPatient(newPatient);
    }
    setIsResetConfirmed(true);
    setGoalAssociatedWithBehavior(false);
    setSelectCategory('');
    setSelectedBehaviorIds([]);
    setSelectedGoalIds([]);
    setSelectedSkillIds([]);
    setTherapyType('');
    setInterventions('');
    setAntecedent('');
    setConsequence('');
    setOtherInputValue('');
    setEditAndViewIds([]);
    setViewOnlyIds([]);
    setVideoFeedBackNotesPrivate('');
    setInformation({ notes: '' });
    handleDialog();
  };

  return {
    handleGoalAssociatedWithBehavior,
    handleSelectCategory,
    handleGoalIdChange,
    handleBehaviorIdChange,
    handleSkillIdChange,
    handleFileChange,
    handleCustomFileNameChange,
    dateChangeHandler,
    handleStudentSelection,
    handlePatientSelection,
    handleDialog,
    handleClose,
    handleConfirmChange,
  };
};

export default useUploadHandlers;
